import { BellOutlined, SettingOutlined } from '@ant-design/icons';
import NotificationManager from '../NotificationManager/NotificationManager';
import CreateDocuments from '../CreateDocuments/CreateDocuments';
import UserDropdownMenu from '../Helper/UserDropDownMenu';
import React from 'react';
import { SETTINGS_ROUTE } from '../../constants/common';
import { useNavigate, useLocation } from 'react-router-dom';
import { Flex } from 'antd';
import SearchUI from '../SearchUI';
import './header.css';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import CreateButton from '../CreateButton/CreateButton';

const Header = ({ propStyle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (location.pathname.includes('settings')) {
    return null; // Do not render header on settings pages
  }
  return (
    <>
      {!isMobile && (
        <>
          <Flex className="header-wrapper" style={{ ...propStyle }}>
            <SearchUI />
            <div className="header-right-section">
              <SettingOutlined onClick={() => navigate(`${SETTINGS_ROUTE}/account-information`)} />
              <NotificationManager>
                <BellOutlined style={{ fontSize: '16px' }} />
              </NotificationManager>
              <UserDropdownMenu />
              <CreateButton />
            </div>
          </Flex>

          <CreateDocuments />
        </>
      )}
    </>
  );
};

export default Header;
